export default __webpack_public_path__ + "static/illustration-content-card.url-834a879f436d2d9c838b2e814414bf66.svg";